/** Money formatting + totals for printed line-item tables. */
import type { OrderLineItem } from '../../types/orders';

export function formatPrintPrice(val: string | number | null | undefined): string {
  if (val === null || val === undefined) return '-';
  const num = typeof val === 'string' ? parseFloat(val) : val;
  if (isNaN(num)) return '-';
  return `$${num.toFixed(2)}`;
}

export function lineItemsTotal(lineItems: OrderLineItem[]): number {
  return lineItems.reduce((sum, li) => {
    const val = parseFloat(li.line_total ?? '');
    return sum + (isNaN(val) ? 0 : val);
  }, 0);
}
